import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    useStyleConfig,
    Image,
    Text,
    Box,
    IconButton,
    Heading
} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'

export const Certificates = ({certificates}) => {
    const [overlayData, setOverlayData] = useState(null)

    const {formatMessage} = useIntl()
    const styles = useStyleConfig('Specifications')
    return (
        <>
            {certificates.length > 0 && (
                <Flex {...styles.certificates}>
                    {certificates?.map((certificate) => (
                        <IconButton
                            onClick={() =>
                                setOverlayData({
                                    id: certificate?.id,
                                    name: certificate?.name,
                                    image: certificate?.image,
                                    description: certificate?.description
                                })
                            }
                            key={certificate?.id}
                            aria-label={certificate?.name}
                            style={{
                                ...styles.certificateButton
                            }}
                            variant="unstyled"
                            icon={
                                <Image
                                    alt={certificate?.name}
                                    src={certificate?.image}
                                    width="auto"
                                    height="100%"
                                />
                            }
                        ></IconButton>
                    ))}
                    <Modal
                        isCentered
                        isOpen={overlayData !== null}
                        onClose={() => setOverlayData(null)}
                        variant="certificate"
                    >
                        <ModalOverlay />
                        <ModalContent
                            aria-label={formatMessage({
                                id: 'product_view.header.awards_and_certificates',
                                defaultMessage: 'Warranty & Certificates'
                            })}
                        >
                            <ModalCloseButton />
                            <ModalBody>
                                <Text as={'h2'} {...styles.certificateModalTitle}>
                                    <FormattedMessage
                                        id="product_view.header.awards_and_certificates"
                                        defaultMessage="Warranty & Certificates"
                                    />
                                </Text>
                                <Flex {...styles.certificateModalContentWrapper}>
                                    <Box {...styles.certificateModalImageContainer}>
                                        <Image
                                            key={overlayData?.id}
                                            alt={overlayData?.name}
                                            src={overlayData?.image}
                                            {...styles.certificateModalImage}
                                        ></Image>
                                    </Box>
                                    <Heading as="h3" {...styles.certificateModalName}>
                                        {overlayData?.name}
                                    </Heading>
                                    <Text {...styles.certificateModalDescription}>
                                        {overlayData?.description}
                                    </Text>
                                </Flex>
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                </Flex>
            )}
        </>
    )
}

Certificates.propTypes = {
    certificates: PropTypes.array,
    maxItems: PropTypes.number
}

export default Certificates
